<template>
    <div class="thank-you">
        <div class="container">
            <div class="thank-you-card">
                <div class="header-section">
                    ชำระเงินสำเร็จ
                </div>
                <div class="content-section">
                    <div class="title">ขอบคุณสำหรับการสั่งซื้อ</div>
                    <div v-if="isContentReady" class="order-info">
                        <div class="info-row">
                            <span class="label">เลขออเดอร์สำหรับติดตาม</span>
                            <span class="value">{{ orderDetail.orderNumber }}</span>
                        </div>
                        <div class="info-row">
                            <span class="label">ยอดรวม</span>
                            <span class="value">{{ orderDetail.finalPrice }} THB</span>
                        </div>
                    </div>
                    <div v-else class="loading-spinner">
                        <b-icon icon="arrow-repeat"></b-icon>
                    </div>
                    <div class="thank-you-icon">
                        <b-icon icon="bag-check"></b-icon>
                        <div class="thank-you-text">Thank You!</div>
                    </div>
                    <div class="message">
                        <p>เราได้จัดส่งอีเมล ยืนยันการสั่งซื้อแล้ว</p>
                    </div>
                    <div v-if="isContentReady" class="action-section">
                        <router-link :to="`/order/receipt/${$route.query.id}`" class="btn btn-main">ดูใบสั่งซื้อ</router-link>
                    </div>
                    <div v-else class="action-section">
                        <div class="loading-spinner">
                            <b-icon icon="arrow-repeat"></b-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Helper from '@/services/helper';
import RouterPath from '@/router/path';
import Constants from '@/variables/constants';
import OrderService from '@/services/orderService';
import GTMService from '@/services/gtmService';

export default {
	components: {
	},
	data() {
		return {
			isContentReady: false,
			orderDetail: null
		};
	},
	mounted() {
        this.getContent();
    },
	methods: {
        async getContent() {
            this.isContentReady = false;

			const param = {
				id: this.$route.query.id
			};
            const result = await OrderService.getOrderDetail(param);

			if (result.data) {
				this.orderDetail = result.data;
				this.isContentReady = true;

				// GTM Purchase
				this.gtmPurchase();

			} else {
				this.$router.push(RouterPath.NOT_FOUND);
			}
        },
        async gtmPurchase() {
			const urlParts = location.pathname.split('/');

			if (!urlParts.includes('my')) {
                const result = await GTMService.validateGTMPurchase(this.orderDetail.orderNumber);

                if (!result.data.isTracked) {
                    GTMService.gtmPurchase(
                        this.$gtm,
                        this.orderDetail.orderNumber,
                        this.orderDetail.finalPrice,
                        this.orderDetail.includeVatPrice !== '-' ? this.orderDetail.includeVatPrice : '',
                        this.orderDetail.orderType === Constants.ORDER_TYPE.DELIVERY ? this.orderDetail.deliveryData.price : '',
                        this.setGTMPurchaseItems()
                    );

                    // Mark flag to prevent reload page
                    GTMService.trackGTMPurchase(this.orderDetail.orderNumber);
                }
			}
		},
		setGTMPurchaseItems() {
            const items = [];

            this.orderDetail.products.forEach((item) => {
                const productId = parseInt(item.param.split('.')[0]);
                const storeId = this.orderDetail.storeData.param.split('.')[0];
                let type = '';

                switch (this.orderDetail.orderType) {
                    case Constants.ORDER_TYPE.SERVICE:
                        type = 'install';
                        break;

                    case Constants.ORDER_TYPE.DELIVERY:
                        type = 'delivery';
                        break;
                }

                items.push({
                    item_id: productId,
                    item_name: item.fullName,
                    item_brand: item.brand,
                    item_category: type,
                    item_category2: item.sellerProductId,
                    item_category3: storeId,
                    discount: item.totalDiscount ? parseFloat(item.totalDiscount?.replace(/,/g, '')) : 0,
                    price: item.totalPrice ? parseFloat(item.totalPrice?.replace(/,/g, '')) : 0,
                    quantity: item.quantity
                });
            });

            return items;
        }
	},
	metaInfo() {
		const title = 'ขอบคุณสำหรับการสั่งซื้อ YELLOWTiRE';
		const desc = 'ขอบคุณสำหรับการสั่งซื้อ เราได้จัดส่งอีเมลยืนยันการสั่งซื้อแล้ว';
		const image = location.origin + Helper.metaDefault().logo;
		
        return {
            title: title,
            meta: [
                { vmid: 'author', name: 'author', content: Helper.metaDefault().author },
				{ vmid: 'publisher', name: 'publisher', content: Helper.metaDefault().publisher },
                { vmid: 'keyword', name: 'keywords', content: Helper.metaDefault().keyword },
                { vmid: 'desc', name: 'description', content: desc },
                { vmid: 'og-url', property: 'og:url', content: location.href },
                { vmid: 'og-title', property: 'og:title', content: title },
                { vmid: 'og-desc', property: 'og:description', content: desc },
                { vmid: 'og-type', property: 'og:type', content: 'website' },
                { vmid: 'og-image', property: 'og:image', content: image },
                { vmid: 'twitter-description', property: 'twitter:description', content: desc },
                { vmid: 'twitter-title', property: 'twitter:title', content: title },
                { vmid: 'twitter-image', property: 'twitter:image', content: image }
            ]
        }
	}
}
</script>

<style lang="scss" scoped>
@import '@/theme/Variable.scss';

.thank-you {
	padding: 20px;
	margin: 30px 0;
	
	.container {
		max-width: 600px;
		margin: 0 auto;
	}
	
	.thank-you-card {
		background: #fff;
		border-radius: 8px;
		overflow: hidden;
		
		.header-section {
			background: #4c4c4c;
			color: #fff;
			padding: 15px 20px;
			font-size: 24px;
			font-weight: bold;
			font-family: 'Open Sans', 'Kanit';
			text-align: center;
		}
		
		.content-section {
			background: #fff;
			padding: 40px 30px;
			text-align: center;
			
			.title {
				font-size: 20px;
                font-family: 'Open Sans', 'Kanit';
                font-weight: bold;
				margin-bottom: 25px;
				color: #000;
			}
			
			.order-info {
				background: transparent;
				text-align: left;
				display: inline-block;
				font-family: 'Open Sans', 'Kanit';
				
				.info-row {
					display: flex;
					justify-content: space-between;
					margin-bottom: 4px;
					font-size: 13px;
					
					.label {
						color: #333;
                        width: 155px;
					}
					
					.value {
						color: #000;
                        font-weight: bold;
					}
				}
			}
			
			.thank-you-icon {
				margin: 30px 0;
				text-align: center;

				::v-deep .b-icon {
					font-size: 80px;
					color: #13a79f;
					display: block;
					margin: auto;
				}
				
				.thank-you-text {
					font-size: 48px;
					font-weight: bold;
					font-style: italic;
					color: #719ea9;
					font-family: 'Open Sans', 'Kanit';
					text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
				}
			}
			
			.message {
				margin-top: 30px;
				
				p {
					font-size: 16px;
					color: #333;
					margin-bottom: 0;
                    font-family: 'Open Sans', 'Kanit';
				}
			}
			
			.action-section {
				margin-top: 30px;

                .btn {
                    font-family: 'Open Sans', 'Kanit';
                    font-weight: bold;
                    font-size: 18px;
                    padding: 12px 30px;
                }
			}
			
			.loading-spinner {
				margin: 20px 0;
				
				::v-deep .b-icon {
					font-size: 24px;
					color: #666;
					display: inline-block;
					animation: spin 1s linear infinite;
				}
			}
		}
	}
	
	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
	
	.loading {
		text-align: center;
		padding: 50px;
		font-size: 18px;
		color: #666;
	}
}

@media (max-width: 768px) {
	.thank-you {
		padding: 10px;
		margin: 20px 0;
		
		.thank-you-card {
			.content-section {
				padding: 30px 20px;
				
				.title {
					font-size: 18px;
				}
				
				.thank-you-icon {
					::v-deep .b-icon {
						font-size: 36px;
					}
					
					.thank-you-text {
						font-size: 36px;
					}
				}
			}
		}
	}
}
</style>